import { convert } from '@revenuemarket/utils';
import { Address } from 'react-daum-postcode';

export interface ParsedAddress {
  state: string;
  city: string;
  street: string;
  postalCode?: string;
}

function findStreetAddress({
  rawAddress,
  sigungu,
  city,
}: {
  rawAddress: string;
  sigungu: string;
  city: string;
}) {
  if (sigungu.length > 0) {
    return rawAddress.substring(Math.max(0, rawAddress.indexOf(sigungu)) + sigungu.length + 1);
  }
  if (city.length > 0) {
    return rawAddress.substring(Math.max(0, rawAddress.indexOf(city)) + city.length + 1);
  }
  return rawAddress;
}

export function parseAddress(data: Address): ParsedAddress {
  switch (data.userSelectedType) {
    case 'R': {
      const rawAddress = data.autoRoadAddress || data.roadAddress;
      return {
        state: data.sido,
        city: data.sigungu,
        street: findStreetAddress({
          rawAddress,
          sigungu: data.sigungu,
          city: data.sido,
        }),
        postalCode: data.zonecode,
      };
    }
    case 'J': {
      const rawAddress = data.autoJibunAddress || data.jibunAddress;
      return {
        state: data.sido,
        city: data.sigungu,
        street: findStreetAddress({
          rawAddress,
          sigungu: data.sigungu,
          city: data.sido,
        }),
        postalCode: data.zonecode,
      };
    }
  }
}

export function formatAddress(address: ParsedAddress) {
  return (
    (convert(address.postalCode, (postalCode) => `(${postalCode}) `) ?? '') +
    [address.state, address.city, address.street].filter(Boolean).join(' ')
  );
}
